// Centralized URL helpers for assets served by the backend (e.g., /uploads/...)

// Normalized base, guaranteed to end with exactly one '/'
export const API_BASE = ((process.env.REACT_APP_BASE_URL || 'http://localhost:5000/')
  .replace(/\/$/, '')) + '/';

// Build a full URL for an asset path that might be absolute (http) or relative (uploads/...)
export function buildAssetUrl(assetPath) {
  if (!assetPath) return '';
  if (assetPath.startsWith('http')) return assetPath;
  return API_BASE + assetPath.replace(/^\/+/, '');
}


